import type { TextContent } from '@mawkaa/types';
import { cn } from '@mawkaa/ui';

interface TextBlockProps {
  content: TextContent;
  isEditing?: boolean;
}

export function TextBlock({ content, isEditing }: TextBlockProps) {
  const { content: htmlContent, alignment = 'left' } = content;

  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  return (
    <section className="px-4 py-12">
      <div className={cn('max-w-4xl mx-auto prose prose-lg', alignmentClasses[alignment])}>
        {htmlContent ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : isEditing ? (
          <p className="text-muted-foreground italic">Cliquez pour ajouter du texte...</p>
        ) : null}
      </div>
    </section>
  );
}
